import React from "react";

const AfterpayClearpay = (props) => {
  return (
    <svg
      height={32}
      width={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{"bacs_debit"}</title>
      <g
        id="afterpay_clearpay"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M28.6315789,6 L3.36842105,6 C2.02631579,6 1,7.02916667 1,8.375 L1,22.625 C1,23.9708333 2.10526316,25 3.36842105,25 L28.6315789,25 C29.9736842,25 31,23.9708333 31,22.625 L31,8.375 C31,7.02916667 29.8947368,6 28.6315789,6 Z"
          id="Path"
          fill="#B2FCE4"
          fillRule="nonzero"
        ></path>
        <path
          d="M22.8960013,11.8368672 L20.6677906,10.5559033 L18.4395799,9.27493938 C16.954106,8.47433693 15.0560006,9.51512012 15.0560006,11.1963853 L15.0560006,11.5166263 C15.0560006,11.6767467 15.1385269,11.8368672 15.3035796,11.9169275 L16.3764218,12.4773492 C16.7065271,12.6374697 17.0366324,12.397289 17.0366324,12.077048 L17.0366324,11.436566 C17.0366324,11.116325 17.3667377,10.8761443 17.696843,11.0362648 L19.760001,12.1571082 L21.7406328,13.3580119 C22.0707381,13.5181324 22.0707381,13.9184336 21.7406328,14.0785541 L19.6774747,15.1993975 L17.6143166,16.4803615 C17.2842113,16.640482 16.954106,16.4003012 16.954106,16.0800602 L16.954106,15.7598193 C16.954106,14.0785541 15.0560006,13.0377709 13.5705268,13.8383734 L11.3423161,15.1193373 L9.11410536,16.4003012 C7.62863155,17.2009037 7.62863155,19.3625303 9.11410536,20.1631328 L11.3423161,21.4440967 L13.5705268,22.7250606 C15.0560006,23.5256631 16.954106,22.4848799 16.954106,20.8036147 L16.954106,20.4833737 C16.954106,20.3232533 16.8715797,20.1631328 16.7065271,20.0830725 L15.6336849,19.5226508 C15.3035796,19.3625303 14.9734743,19.602711 14.9734743,19.922952 L14.9734743,20.563434 C14.9734743,20.883675 14.643369,21.1238557 14.3132637,20.9637352 L12.2501056,19.8428918 L10.1869476,18.6419881 C9.85684227,18.4818676 9.85684227,18.0815664 10.1869476,17.9214459 L12.2501056,16.8006025 L14.3132637,15.679759 C14.643369,15.5196385 14.9734743,15.7598193 14.9734743,16.0800602 L14.9734743,16.4003012 C14.9734743,18.0815664 16.8715797,19.1223496 18.3570535,18.3217471 L20.5852643,17.0407832 L22.813475,15.7598193 C24.3814751,14.7990963 24.3814751,12.7175299 22.8960013,11.8368672 Z"
          id="Path"
          fill="#000000"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  );
};

export default AfterpayClearpay;
